import React from "react";
import { useTranslation } from "react-i18next";
import constructionIcon from "../assets/construction.svg";

const styles = {
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "200px",
    height: "auto",
  },
  text: {
    marginTop: "20px",
    color: "#333",
    fontFamily: "sans-serif",
  },
};

const FeatureNotImplemented = ({ FeatureName }) => {
  const { t } = useTranslation();
  const featureName = FeatureName;

  return (
    <div style={styles.container}>
      <img
        src={constructionIcon}
        alt="Under Construction"
        style={styles.image}
      />
      <h1 style={styles.text}>
        {t("FeatureNotImplemented.message", { FeatureName: featureName })}
      </h1>
    </div>
  );
};

export default FeatureNotImplemented;
